import { useSelector } from 'react-redux';

/**
 * Whether the user has a member profile in the current organisation.
 * In a multi-entity setup an HR can manage organisations they are not a member of; the default entity is the one
 * they belong to, so the profile only exists there. Single-organisation users always have one.
 */
const useCanViewProfile = (): boolean => {
  const { chosenEntity, canChooseEntity } = useSelector((state: any) => state.multiEntity || {});

  if (!canChooseEntity || !chosenEntity) return true;
  return chosenEntity.is_default === true;
};

export default useCanViewProfile;
